import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { FailActivity } from 'app/model/pipeline/fail.activity';
import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { ActivityAsyncAdapter } from 'app/model/adapters/activities/activity.adapter';

import { ValueAdapter } from 'app/model/adapters/value.adapter';
import _ from 'lodash';
import { IFailActivityContext } from 'app/interfaces/copilot.pipeline.action.types';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(FailActivity),
    asynchronous: true,
    adapts: {
        name: '*',
        type: '*',
        description: '*',
        dependsOn: '*',
        policy: '*',
        userProperties: '*',
        typeProperties: {
            message : '*',
            errorCode: '*'
        }
    }
})
export class FailActivityAdapter extends ActivityAsyncAdapter<FailActivity, Model.FailActivity, IFailActivityContext> {

    public model(): IModel {
        return Metamodel.modelFor(FailActivity);
    }

    public override async toFabricCopilotContext(activity: FailActivity): Promise<IFailActivityContext> {
        if (activity) {
            const activityContext: IFailActivityContext = await super.toFabricCopilotContext(activity);
            activityContext.FailureMessage = ValueAdapter.toResource(activity, FailActivity.MESSAGE, true);
            activityContext.FailureErrorCode = ValueAdapter.toResource(activity, FailActivity.ERROR_CODE, true);
            return activityContext;
        }
        return undefined;
    }

    public override async fromFabricCopilotContext(
        context: IFailActivityContext,
        model?: FailActivity
    ): Promise<FailActivity> {
        if (context) {
            model = await super.fromFabricCopilotContext(context, model);
            ValueAdapter.toModel(model, FailActivity.MESSAGE, context.FailureMessage);
            ValueAdapter.toModel(model, FailActivity.ERROR_CODE, context.FailureErrorCode);
        }
        return model;
    }

    protected async _toResource(activity: FailActivity): Promise<Model.FailActivity> {
        const modelFailActivity: Model.FailActivity = super._getCommonActivityProperties(activity, 'Fail') as Model.FailActivity;

        modelFailActivity.typeProperties = {
            message : ValueAdapter.toResource(activity, FailActivity.MESSAGE),
            errorCode : ValueAdapter.toResource(activity, FailActivity.ERROR_CODE)
        };

        if (activity.raw) {
            const parsed = JSON.parse(activity.raw);
            _.merge(modelFailActivity, parsed);
        }

        return modelFailActivity;
    }

    protected async _toModel(modelActivity: Model.FailActivity): Promise<FailActivity> {
        const activity: FailActivity = FailActivity.MODEL.create<FailActivity>(modelActivity.name);
        this._updatedCommonProperties(modelActivity, activity);
        modelActivity.typeProperties = modelActivity.typeProperties || { message: '', errorCode: '' };
        ValueAdapter.toModel(activity, FailActivity.MESSAGE, modelActivity.typeProperties.message);
        ValueAdapter.toModel(activity, FailActivity.ERROR_CODE, modelActivity.typeProperties.errorCode);

        activity.raw = JSON.stringify(await ValueAdapter.remainder(this.context, modelActivity, FailActivity.MODEL));
        return activity;
    }
}
